import React from 'react';
import { useTranslationContext } from "../context/TranslationsProvider";

const Button = ({ onClick, children, disabled }) => {
    const { translations } = useTranslationContext();
    const t = (key, fallback) => translations[key] || fallback;
  return (
    <button onClick={onClick} disabled={disabled} className="simulator-button">
      {t('bdo-libranza-button-simulate', children)}
    </button>
  );
};

export default Button;
